import { useTranslation } from "react-i18next";

type ChangeLinkProps = {
  onClick: () => void;
  label?: string;
};

export function ChangeLink({ onClick, label }: ChangeLinkProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className="-mx-2.5 -my-1.5 whitespace-nowrap rounded-md px-2.5 py-1.5 max-md:-my-3 max-md:py-3 [@media(pointer:coarse)]:-my-3 [@media(pointer:coarse)]:py-3 text-sm font-medium text-indigo-600 hover:bg-indigo-50 hover:text-indigo-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
    >
      {label ?? t("settings_change")}
    </button>
  );
}
